import { usePointUnbindStream } from '@entities/point';

import { NOTIFICATION_DEFAULT_ERROR_MESSAGE, useNotificationContext } from 'application/providers/NotificationProvider';
import { TEXTS } from 'application/pages/PointsPage/renderer/texts';

import { StreamUnbindModalViewModelProps } from './types';

const useStreamUnbindModalViewModel = ({ pointId, close }: StreamUnbindModalViewModelProps) => {
  const notification = useNotificationContext();

  const { request, loading } = usePointUnbindStream();

  const handleClose = () => {
    if (!loading) {
      close();
    }
  };

  const handleUnbind = async () => {
    try {
      const ok = await request(pointId);

      if (!ok) {
        throw new Error();
      }

      close();

      notification.showInfoNotification({
        children: TEXTS.POINT_STREAM_UNBIND_MODAL_SUCCESS_TEXT,
      });
    } catch {
      notification.showErrorNotification({
        children: NOTIFICATION_DEFAULT_ERROR_MESSAGE,
      });
    }
  };

  return {
    handleClose,
    handleUnbind,
    isLoading: loading,
  };
};

export default useStreamUnbindModalViewModel;
